import updateItemRequest from 'owa-service/lib/factory/updateItemRequest';
import itemId from 'owa-service/lib/factory/itemId';
import itemChange from 'owa-service/lib/factory/itemChange';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import updateItemOperation from 'owa-service/lib/operation/updateItemOperation';
import createSetItemField from 'owa-mail-store/lib/services/utils/createSetItemField';
function createRequestBody(itemIdsToUpdate, inferenceClassification) {
    var itemChanges = [];
    for (var _i = 0, itemIdsToUpdate_1 = itemIdsToUpdate; _i < itemIdsToUpdate_1.length; _i++) {
        var messageItemId = itemIdsToUpdate_1[_i];
        var update = createSetItemField('InferenceClassification', inferenceClassification);
        var singleItemChange = itemChange({
            Updates: [update],
            ItemId: itemId({
                Id: messageItemId,
            }),
        });
        itemChanges.push(singleItemChange);
    }
    return updateItemRequest({
        ConflictResolution: 'AlwaysOverwrite',
        ItemChanges: itemChanges,
        OutboundCharset: 'AutoDetect',
    });
}
export default function setItemsInferenceClassificationService(itemIdsToUpdate, inferenceClassification) {
    var requestBody = createRequestBody(itemIdsToUpdate, inferenceClassification);
    // We want to always set the pin time in UTC time, so it's invariant to user time zone
    var jsonRequestHeader = getJsonRequestHeader();
    jsonRequestHeader.TimeZoneContext.TimeZoneDefinition.Id = 'UTC';
    return updateItemOperation({
        Header: jsonRequestHeader,
        Body: requestBody,
    }).then(function (response) {
        return response.Body.ResponseMessages.Items[0];
    });
}
//# sourceMappingURL=setItemsInferenceClassificationService.js.map